import moment from 'moment';
import React, { useEffect, useState } from 'react';

import Searchbar from '../../../components/Searchbar';
import AlertService from '../../../components/SweetAlert';
import ToastUtil from '../../../components/ToastNotification/ToastUtil';
import { config } from '../../../config/index';
import { DELETE, newFetch } from '../../../helpers/fetch';
const { API_URL } = config;

const Notifications = () => {
  const token = localStorage.getItem('token');
  let user = JSON.parse(localStorage.getItem('user'));
  let type = localStorage.getItem('type');

  if (type === 'superadmin') type = 'admin';

  const [notifications, setNotifications] = useState([]);
  const [filteredNotifications, setFilteredNotifications] = useState([]);

  const fetchNotifications = async () => {
    let url = `${API_URL}/notification/${type}/mynotifications`;
    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();
        setNotifications(data.data);
        setFilteredNotifications(JSON.parse(JSON.stringify(data.data)));
      } else {
        ToastUtil.error('Failed to fetch notifications!');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [selectedIds, setSelectedIds] = useState([]);

  const checkboxHandler = (e) => {
    if (e.target.checked) {
      let updatedSelectedIds = [...selectedIds];

      updatedSelectedIds.push(parseInt(e.target.value));
      setSelectedIds(updatedSelectedIds);
    } else {
      let updatedSelectedIds = [...selectedIds].filter(
        (id) => id !== parseInt(e.target.value)
      );

      setSelectedIds(updatedSelectedIds);
    }
  };

  const checkboxAllOn = (e) => {
    if (e.target.checked) {
      let notification_ids = filteredNotifications.map((admin) => admin.id);
      setSelectedIds(notification_ids);
    } else {
      setSelectedIds([]);
    }
  };

  const searchHandler = (e) => {
    let filtered = [...notifications].filter((notification) => {
      return (
        notification.title.toUpperCase().indexOf(e.target.value.toUpperCase()) >
        -1
      );
    });
    setFilteredNotifications(filtered);
  };

  const deleteNotification = async (id) => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete this Notification?'
      )
    ) {
      const url = `/notification/${type}/${user.id}`;
      let response = await newFetch(DELETE, url, {
        notifications: [id],
      });

      if (response.success) {
        ToastUtil.error('Notification successfully deleted!');
        fetchNotifications();
      }
    }
  };

  const readSelectedHandler = async () => {
    let url = `${API_URL}/notification/${type}/${user.id}/read`;

    try {
      let response = await fetch(url, {
        method: 'PUT',
        body: JSON.stringify({ notifications: selectedIds }),
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        await fetchNotifications();
        setSelectedIds([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const deleteSelectedHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete these Notifications?'
      )
    ) {
      let url = `${API_URL}/notification/${type}/${user.id}`;

      try {
        let response = await fetch(url, {
          method: 'DELETE',
          body: JSON.stringify({ notifications: selectedIds }),
          withCredentials: true,
          mode: 'cors',
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        if (response.ok) {
          await fetchNotifications();
          setSelectedIds([]);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <div
      className="container-fluid mb-4"
      style={{ paddingLeft: '2rem', paddingRight: '2rem' }}
    >
      <div className="border-bottom pb-2 py-2 mb-3 d-flex align-items-center">
        <h6 className="flex-grow-1 pt-4" style={{ color: '#5156BE' }}>
          Notifications
        </h6>
      </div>

      <Searchbar
        search={(e) => searchHandler(e)}
        placeholder="Search notification"
        width="100%"
      />

      <div className="table-responsive rounded adjust-shadow bg-white mt-3">
        <table className="table table-borderless mb-0">
          <thead className="border-bottom">
            <tr>
              <th width="10px" className="py-3 text-muted fw-normal">
                <div className="form-check">
                  <input
                    className="form-check-input position-static"
                    onChange={checkboxAllOn}
                    type="checkbox"
                  />
                </div>
              </th>
              {selectedIds.length > 0 ? (
                <React.Fragment>
                  <th
                    colSpan={2}
                    width="10px"
                    className="py-3 text-muted fw-normal"
                  >
                    <strong className="text-muted">Unselect/Select</strong>
                  </th>
                  <th
                    width="15%"
                    className="py-3 text-end text-muted fw-normal"
                  >
                    <div
                      className="text-brand fw-semibold"
                      style={{ cursor: 'pointer' }}
                      onClick={readSelectedHandler}
                    >
                      Mark as Read
                    </div>
                  </th>
                  <th width="10%" className="py-3 text-end fw-semibold">
                    <div
                      className="text-danger"
                      style={{ cursor: 'pointer' }}
                      onClick={deleteSelectedHandler}
                    >
                      Delete
                    </div>
                  </th>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <th width="10px" className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th width="15%" className="py-3 text-muted fw-normal"></th>
                  <th width="10%" className="py-3 text-muted fw-normal"></th>
                </React.Fragment>
              )}
            </tr>
          </thead>
          <tbody>
            {filteredNotifications.map((notification) => {
              return (
                <tr key={notification.id} className="border-bottom">
                  <td>
                    <div className="form-check">
                      <input
                        className="form-check-input position-static"
                        type="checkbox"
                        checked={selectedIds.some(
                          (id) => id === notification.id
                        )}
                        value={notification.id}
                        onChange={checkboxHandler}
                      />
                    </div>
                  </td>
                  <td
                    colSpan={2}
                    className={
                      notification.is_read === false
                        ? 'fw-bold text-muted'
                        : 'text-muted'
                    }
                  >
                    {notification.is_read === false && (
                      <i
                        className="text-danger fas fa-circle me-4"
                        style={{ fontSize: '0.5rem' }}
                      />
                    )}
                    {notification.title}
                  </td>
                  {/* <td
                    className={
                      notification.is_read === false
                        ? 'fw-bold text-muted'
                        : 'text-muted'
                    }
                  >
                    {notification.title}
                  </td> */}
                  <td className="text-end text-muted">
                    {moment(notification.createdAt).fromNow()}
                  </td>
                  <td className="text-end">
                    <div
                      style={{ cursor: 'pointer' }}
                      className="dropdown custom-dropdown"
                    >
                      <button
                        className="btn dropdown-toggle adjust-fs"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i
                          className="fas fa-ellipsis-h"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        ></i>
                      </button>
                      <div
                        className="dropdown-menu dropdown-menu-right"
                        style={{ width: '150px' }}
                      >
                        <div
                          onClick={() => deleteNotification(notification.id)}
                          style={{ cursor: 'pointer' }}
                          className="dropdown-item pt-2"
                        >
                          Delete
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Notifications;
